export default __webpack_public_path__ + "static/media/914.00b7d96f.gif";